module.exports = __webpack_public_path__ + "static/img/IMG_20170325_184800.11016eea.jpg";